"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Konfektionierung = void 0;
const echain_shared_oo_1 = require("@igus/echain-shared-oo");
const echain_shared_validation_1 = require("@igus/echain-shared-validation");
const Article_1 = require("../Article");
const echain_product_models_1 = require("@igus/echain-product-models");
class Konfektionierung extends Article_1.Article {
    constructor() {
        super(...arguments);
        this.className = 'Konfektionierung';
    }
    get typ() {
        return this.model.Typ;
    }
    set typ(value) {
        this.model.Typ = value;
    }
    get basePriceVK() {
        return this.model.BasePriceVK;
    }
    set basePriceVK(value) {
        this.model.BasePriceVK = value;
    }
    get basePriceEK() {
        return this.model.BasePriceEK;
    }
    set basePriceEK(value) {
        this.model.BasePriceEK = value;
    }
    get calculatedPriceVK() {
        return this.model.CalculatedPriceVK;
    }
    set calculatedPriceVK(value) {
        this.model.CalculatedPriceVK = value;
    }
    get calculatedPriceEK() {
        return this.model.CalculatedPriceEK;
    }
    set calculatedPriceEK(value) {
        this.model.CalculatedPriceEK = value;
    }
    static fromScratch(typ) {
        return new Konfektionierung({
            ArticleType: echain_product_models_1.ArticleType.konfektionierung,
            EntityId: echain_shared_oo_1.UUIDGenerator.new(),
            Typ: typ,
        });
    }
    static fromExistingArtNr(args, cloneStrategy = 'deep') {
        const msg = 'Konfektionierung.fromExistingArtNr: ';
        echain_shared_validation_1.Validation.throws([
            echain_shared_validation_1.Validator.definedNotNull(args.Id, msg + 'Id: '),
            echain_shared_validation_1.Validator.truthy(args.ArtNr || args.ArtNrGenerated, msg + 'ArtNr || ArtNrGenerated: '),
        ]);
        const konfektionierung = Konfektionierung.fromJson(args, cloneStrategy);
        konfektionierung.artNrExists = true;
        return konfektionierung;
    }
    static fromInventedArtNr(args, cloneStrategy = 'deep') {
        const msg = 'Konfektionierung.fromInventedArtNr: ';
        echain_shared_validation_1.Validation.throws([echain_shared_validation_1.Validator.truthy(args.ArtNr || args.ArtNrGenerated, msg + 'ArtNr || ArtNrGenerated: ')]);
        const konfektionierung = Konfektionierung.fromJson(args, cloneStrategy);
        konfektionierung.artNrExists = false;
        return konfektionierung;
    }
    static fromJson(args, cloneStrategy = 'deep') {
        if (!args.Typ) {
            throw new Error(`Konfektionierung.fromJson() no KonfektionierungTyp defined`);
        }
        const konfektionierung = Konfektionierung.fromScratch(args.Typ);
        konfektionierung.fromJson(args, cloneStrategy);
        return konfektionierung;
    }
    static fromModel(model) {
        const konfektionierung = Konfektionierung.fromScratch(model.Typ);
        Object.assign(konfektionierung.model, model);
        Object.assign(model, konfektionierung.model);
        konfektionierung.model = model;
        return konfektionierung;
    }
    clone() {
        return this._clone(Konfektionierung.fromScratch(this.typ));
    }
    duplicate() {
        return this._duplicate();
    }
}
exports.Konfektionierung = Konfektionierung;
//# sourceMappingURL=Konfektionierung.js.map